<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="PurInvoiceLineViewInfo"
                :filter_language="['balancemode_name','invoice_status']"
                :filter_thousandth="['invoice_qty']"
                :filter_thousandth_purprice="['net_unit_price','vender_net_unit_price']"
                :filter_thousandth_puramount="['remain_amount','vender_remain_amount','line_net_total_amount','tax_amount','line_total_amount','vender_line_net_total_amount']"
                :filter_date="['invoice_date','payment_date']"
                :header="tableHeader"
                :option="tableOption"
                ref="singleTable"
                :checkflg="false"
        ></wTable>
        <!--<el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
        >
            <el-table-column type="selection" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_year" :label="$t('getapi[3677]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_month" :label="$t('getapi[3678]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="audit_year" :label="$t('getapi[3679]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="audit_month" :label="$t('getapi[3680]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="invoice_no" :label="$t('getapi[2992]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="invoice_code" :label="$t('getapi[3681]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="invoice_type_name" :label="$t('getapi[3682]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="invoice_date" :label="$t('getapi[3683]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="order_type_code" :label="$t('getapi[3684]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="balancemode_name" :label="$t('getapi[1228]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1196]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_name" :label="$t('getapi[3685]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="payment_date" :label="$t('getapi[3686]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="currency_code" :label="$t('getapi[3108]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="exchange_rate" :label="$t('getapi[3287]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_remain_amount" :label="$t('getapi[3688]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remain_amount" :label="$t('getapi[3689]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[3690]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_date" :label="$t('getapi[3691]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[4043]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="audit_date" :label="$t('getapi[3692]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="buyer" :label="$t('getapi[1167]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="payment_period" :label="$t('getapi[1600]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="tax_code" :label="$t('getapi[3693]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="tax_rate" :label="$t('getapi[1225]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="invoice_status" :label="$t('getapi[3694]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="exchange_modify_person" :label="$t('getapi[3695]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="exchange_modify_date" :label="$t('getapi[3696]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="audit_period" :label="$t('getapi[3697]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="relation_po_code" :label="$t('getapi[1710]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="receive_order_no" :label="$t('getapi[3709]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="receive_order_line_no" :label="$t('getapi[3710]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="category_first" :label="$t('getapi[169]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="category_second" :label="$t('getapi[170]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="category_third" :label="$t('getapi[171]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[124]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_stuff" :label="$t('getapi[126]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[888]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="invoice_qty" :label="$t('getapi[1628]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="net_unit_price" :label="$t('getapi[3711]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="line_net_total_amount" :label="$t('getapi[3712]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="tax_amount" :label="$t('getapi[1611]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="line_total_amount" :label="$t('getapi[3713]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_net_unit_price" :label="$t('getapi[3714]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_line_net_total_amount" :label="$t('getapi[3715]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="line_remark" :label="$t('getapi[4279]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="relation_regist_order_no" :label="$t('getapi[1744]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="delive_order_no" :label="$t('getapi[1874]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="virtual_flag" :label="$t('getapi[3700]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[876]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="invoicenumlst" :label="$t('getapi[7222]')"></el-table-column>
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="PurInvoiceLineViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[3707]')" queryData="PurInvoiceLineViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'3_purinvoicedetailview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize:  this.$http.getPageSize('PurInvoiceLineViewInfo'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.PlanTypeArray = Array.methods.getPlanType();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('PurInvoiceLineViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[3707]"),this.$t("getapi[3836]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                //只读权
                if (that.$limits.ReadOnlyRightsView('plv2', 65, 1, that.total)) {
                    if (that.total > 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    }
                }
                //操作权限-查询级别
                var limits = that.$limits.OperationAuthorityView('plv2', 65, 1, that.total);
                // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                switch (limits) {
                    case -1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    case -2:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 2:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    case -3:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 3:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    default:
                        break;
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('PurInvoiceLineViewInfo',val);
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'PurInvoiceLineViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let token = JSON.parse(that.userData).token;
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Pur/Invoice/PurInvOverViewDataList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Pur/Invoice/PurInvOverViewExportToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "PurInvoiceLineViewInfo",
                    fromname: that.$t('getapi[3707]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
